<div id="layout-wrapper">

  <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar [isCondensed]="isCondensed" *ngIf="!hideMenu"></app-sidebar>

  <div class="main-content" [ngClass]="{ 'ms-0': hideMenu }">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer [hideMenu]="hideMenu"></app-footer>
  </div>
</div>